import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import * as actionTypes from 'modules/mediaLibrary/actionTypes';

/** @typedef {{ isUpdating: boolean, isDeleting: boolean }} MediaLibraryLoadingReducer */
export default combineReducers({
  isUpdating: loading(actionTypes.UPDATE_MEDIA_LIBRARY),
  isDeleting: loading(actionTypes.DELETE_MEDIA_LIBRARY),
});
